import { v4 } from "uuid";

export const DRAWER_WIDTH = 250;
export const ROWS_PER_PAGE = 100;

export const CREATE_PATIENT_STEPS = [
  "Patient Details",
  "Employment Details",
  "Medical Aid Details",
  "Documents",
];

export const STATUS_FILTER_OPTIONS = [
  "ARRIVED",
  "WAITING",
  "START_EXAM",
  "END_EXAM",
  "QC",
  "DICTATE",
  "TYPIST",
  "AUTHORIZE",
  "DONE",
];

export const fields = [
  {
    name: "Name",
    type: "input",
    config: { label: "Name", required: true, errMsg: "Add persons name" },
  },
  {
    name: "Description",
    type: "input",
    config: {
      label: "What is the apponintment for?",
      multiline: true,
      rows: 4,
      required: true,
      errMsg: "Add persons name",
    },
  },
];

export const WORKLIST_COLUMN_PROPERTIES = [
  { id: "idnumber", label: "ID Number" },
  { id: "accession", label: "Accession" },
  { id: "Claim", label: "Claim Number" },
  { id: "flag", label: "flag" },
  { id: "name", label: "Name" },
  { id: "surname", label: "Surname" },
  { id: "procedure", label: "Procedure" },
  { id: "status", label: "Status" },
  { id: "branch", label: "Branch" },
  // { id: "cancel", label: "  Cancel" },
];

export const WORKLIST_COLUMN_PROPERTIES_REPORTS = [
  { id: "idnumber", label: "ID Number" },
  { id: "accession", label: "Accession" },
  { id: "mrn", label: "MRN" },
  { id: "name", label: "Name" },
  { id: "surname", label: "Surname" },
  { id: "procedure", label: "Procedure" },
  { id: "status", label: "Print-Report" },
  { id: "cancelled", label: "Cancelled" },
  { id: "branch", label: "Branch" },
];

export const WORKLIST_COLUMN_PROPERTIES_REF = [
  { id: "idnumber", label: "ID Number" },
  { id: "accession", label: "Accession" },
  { id: "name", label: "Name" },
  { id: "surname", label: "Surname" },
  { id: "procedure", label: "Procedure" },
  { id: "branch", label: "Branch" },
  { id: "status", label: "Status" },
  { id: "view-scan", label: "View Scan" },
];

export const ROLES = [
  "administrator",
  "radiographer",
  "radiologist",
  "receptionist",
  "typist",
  "ref-doctor",
];

export const relations = [
  "",
  "SON",
  "DAUGHTER",
  "FATHER",
  "WIFE",
  "HUSBAND",
  "SELF",
  "MOTHER",
  "PRISONER",
  "EMPLOYEE",
  "CLIENT",
  "PENSIONR",
  "INFANT",
  "NEW BORN",
  "SISTER",
  "NIECE",
  "FIANCE",
  "CHILD",
  "BROTHER",
  "DEPENDENT",
];

export const allergies = [
  "NONE",
  "SCOLINE APNOEA",
  "PENICILLIN",
  "SUGAR SNAP PEAS, SLOANS HEAT R",
  "METFORMIN",
  "IODINE",
  "BEE STING",
  "PORK",
  "PENN",
  "SINUS",
  "EFILWE P",
  "PENICILLIN, DUST AND GRASS",
  "DICLOFEN",
  "PENICILLIN, AMPICILLAN",
  "A",
  "LACTOSE INTOLERANT",
  "PINEAPPLES",
  "SULPHUR",
  "ID",
  "ENVIRONMENTAL",
  "ECHE",
  "MR",
  "MS",
  "POLLEN",
  "BEES",
  "7",
  "EBECCA",
];

export const medicalAidNames = [
  {
    "label": "AACMED",
    "value": "AACM"
  },
  {
    "label": "AECI",
    "value": "AECI"
  },
  {
    "label": "ALLCARE",
    "value": "ALLC"
  },
  {
    "label": "ALTRON (ALLCARE)",
    "value": "ALTR"
  },
  {
    "label": "BARLOWORLD",
    "value": "BARL"
  },
  {
    "label": "BESTMED",
    "value": "BEST"
  },
  {
    "label": "BONITAS",
    "value": "BONI"
  },
  {
    "label": "CAPE MEDICAL",
    "value": "CAPM"
  },
  {
    "label": "CARE CROSS",
    "value": "CAR"
  },
  {
    "label" : "CASH/CARD",
    "value" : "CASH/CARD"
  },

  {
    "label": "CHARTERED ACCOUNTANT",
    "value": "CHAR"
  },
  {
    "label": "CMS RATES",
    "value": "CMS"
  },
  {
    "label": "COMMED",
    "value": "COMM"
  },
  {
    "label": "CORPORATE FUND MNGRS",
    "value": "NMA"
  },
  {
    "label": "DEBEERS",
    "value": "DEBE"
  },
  {
    "label": "DISCOVERY",
    "value": "DISC"
  },
  {
    "label": "ENABLEMED",
    "value": "ENAB"
  },
  {
    "label": "FEDHEALTH MEDICAL",
    "value": "REEF"
  },
  {
    "label": "GENESIS",
    "value": "GSIS"
  },
  {
    "label": "GLENCOR",
    "value": "GLEN"
  },
  {
    "label": "GOLDFIELDS",
    "value": "GOLD"
  },
  {
    "label": "HORIZON",
    "value": "HORI"
  },
  {
    "label": "HOSMED",
    "value": "HOSM"
  },
  {
    "label": "KEY CARE",
    "value": "KEYC"
  },
  {
    "label": "KEYHEALTH",
    "value": "KEYH"
  },
  {
    "label": "KWA ZULU NATAL",
    "value": "REGI"
  },
  {
    "label": "LIBCARE",
    "value": "LIBC"
  },
  {
    "label": "LIBERTY",
    "value": "LIBE"
  },
  {
    "label": "MAKOTI",
    "value": "MAKO"
  },
  {
    "label": "MALCOR",
    "value": "MALC"
  },
  {
    "label": "MBMED",
    "value": "MBME"
  },
  {
    "label": "MEDICAL PMTS BUREAU",
    "value": "D&amp;E"
  },
  {
    "label": "MEDIHELP",
    "value": "MEDI"
  },
  {
    "label": "MEDIMED",
    "value": "MEDIM"
  },
  {
    "label": "MEDSCHEME",
    "value": "MEDSC"
  },
  {
    "label": "MEDSHIELD",
    "value": "MDSH"
  },
  {
    "label": "MEMBER'S PORTION",
    "value": "MEPO"
  },
  {
    "label": "METROPOLITAN",
    "value": "METRO"
  },
  {
    "label": "MISCELLANEOUS",
    "value": "RATE0"
  },
  {
    "label": "MOMENTUM",
    "value": "NMP"
  },
  {
    "label": "MOTOHEALTH",
    "value": "MOTO"
  },
  {
    "label": "NBC (ALLCARE)",
    "value": "NBC"
  },
  {
    "label": "NEDGROUP",
    "value": "NEDC"
  },
  {
    "label": "NEW WCA RATES",
    "value": "NWCA"
  },
  {
    "label": "NORTHERN GROUP",
    "value": "NORT"
  },
  {
    "label": "OLD MUTUAL",
    "value": "OMMED"
  },
  {
    "label": "OLDMUTUAL",
    "value": "OLDM"
  },
  {
    "label": "OPMED",
    "value": "OPME"
  },
  {
    "label": "PARMED",
    "value": "PARM"
  },
  {
    "label": "PHAROS",
    "value": "PHAR"
  },
  {
    "label": "PLATINUM",
    "value": "PLATI"
  },
  {
    "label": "PRIMECURE",
    "value": "PRIM"
  },
  {
    "label": "PROFMED",
    "value": "PROF"
  },
  {
    "label": "PROFMED",
    "value": "RATE7"
  },
  {
    "label": "RAND WATER",
    "value": "RAND"
  },
  {
    "label": "RATE1",
    "value": "RATE1"
  },
  {
    "label": "RATE2",
    "value": "RATE2"
  },
  {
    "label": "RATE3",
    "value": "RATE3"
  },
  {
    "label": "RATE3",
    "value": "WCA3"
  },
  {
    "label": "RATE4",
    "value": "RATE4"
  },
  {
    "label": "RATE5",
    "value": "RATE5"
  },
  {
    "label": "RATE6",
    "value": "RATE6"
  },
  {
    "label": "RESOLUTION HEALTH",
    "value": "RESO"
  },
  {
    "label": "SABC",
    "value": "SABC"
  },
  {
    "label": "SAMWUMED",
    "value": "SAMW"
  },
  {
    "label": "SANLAM",
    "value": "4"
  },
  {
    "label": "SASOLMED",
    "value": "SASO"
  },
  {
    "label": "SEDMED",
    "value": "SEDM"
  },
  {
    "label": "SELFMED",
    "value": "SELF"
  },
  {
    "label": "SIZWE",
    "value": "MSP"
  },
  {
    "label": "SIZWE",
    "value": "SIZW"
  },
  {
    "label": "SOUTHERN HEALTHCARE",
    "value": "SHC"
  },
  {
    "label": "SOVEREIGN HEALTH",
    "value": "SOVER"
  },
  {
    "label": "SPECTRAMED",
    "value": "SAPR"
  },
  {
    "label": "STATUS",
    "value": "STAT"
  },
  {
    "label": "SUREMED",
    "value": "SURE"
  },
  {
    "label": "SWAZIMED",
    "value": "SWAZI"
  },
  {
    "label": "THEBEMED",
    "value": "THEB"
  },
  {
    "label": "TIGER BRANDS",
    "value": "TIGE"
  },
  {
    "label": "TRANSMED",
    "value": "TRAN"
  },
  {
    "label": "UMVUZU",
    "value": "UMV"
  },
  {
    "label": "UNIVERSAL MEDICAL",
    "value": "UNIV"
  },
  {
    "label": "WCA",
    "value": "WCA"
  },
  {
    "label": "WITBANK COALFIELDS",
    "value": "WITB"
  },
  {
    "label": "WITS MEDICAL",
    "value": "WITS"
  },
  {
    "label": "YEBOMED",
    "value": "YEBO"
  },
  {
    "label": "Counter",
    "value": "85"
  }
];

export const INIT_CREATE_PATIENT_FORM_STATE = {
  PatientDetails: {
    PatientID: parseInt(Math.random()*1000000000, 10),
    SessionID: v4(),
    Branch: "",
    FirstName: "",
    LastName: "",
    Sex: "",
    IDNumber: "",
    PhoneNumber: "",
    Email: "",
    DateOfBirthRaw: null,
    DateOfBirthTimestamp: 0,
    Initials: "",
    Title: "",
    Allergies: "",
    PhysicalAddress: "",
    PostalAddress: "",
  },
  EmploymentDetails: {
    ContactPerson: "",
    EmployerContactNumber: "",
    Occupation: "",
    CompanyName: "",
    CompanyNumber: "",
    EmployerPhysicalAddress: null,
    COIDRef: "",
    COIDEmployerName: "",
    IncidentDate: null ,
    COIDEmployerRegNumber: "",
    COIDEmployeeNumber: "",
  },
  MedicalAidDetails: {
    DependentCode: "null",
    MedicalAidMemberRelationToPatient: "null",
    MedicalAidMemberTitle:"null",
    MedicalAidMemberFirstName: "null",
    MedicalAidMemberLastName: "null",
    MedicalAidMemberInitials:"null",
    MedicalAidMemberIDNumber: "null",
    MedicalAidMemberPhoneNumber: "null",
    MedicalAidMemberPostalAddress: "null",
    MedicalAidName: "null",
    MedicalAidPlan: "null",
    MedicalAidNumber: "null",
    MedicalAidVatNumber: "null",
    MedicalAidMemberMemberEmployerName:"null",
    MedicalAidMemberMemberWorkDepartment:"null",
    MedicalAidMemberMemberOccupation:"null",
    MedicalAidMemberMemberWorkPhone:"null",
    MedicalAidMemberMemberWorkAddress:"null",
  },
  Documents: {
    ID_DOC: null,
    MEDICAL_AID_DOC: null,
    REF_NOTE_DOC: null,
    OTHER_DOC_ONE: null,
    OTHER_DOC_TWO: null,
    OTHER_DOC_THREE: null,
    OTHER_DOC_FOUR: null,
    OTHER_DOC_FIVE: null,
    OTHER_DOC_SIX: null,
    OTHER_DOC_SEVEN: null,
    OTHER_DOC_EIGHT: null,
    OTHER_DOC_NINE: null,
  },
};

export const INIT_FORM_STATE = {
  SessionID: v4(),
  Branch: "",
  FirstName: "",
  LastName: "",
  Sex: "",
  IDNumber: "",
  PhoneNumber: "",
  Email: "",
  DOB: "",
  Initials: "",
  Title: "",
  Allergies: "",
  PostalAddress: "",
  PostalCode: "",
  Occupation: "",
  CompanyName: "",
  CompanyNumber: "",
  MedicalAidFirstname: "",
  MedicalAidLastname: "",
  MedicalAidIDNumber: "",
  MedicalAidPhoneNumber: "",
  MedicalAidMedicalAid: "",
  MedicalAidMedicalAidNumber: "",
  MedicalAidRelationToMember: "",
  MedicalAidVatNumber: "",
  MedicalAidPostalAddress: "",
  MedicalAidPostalCode: "",
};
